import React, { useCallback, useEffect, useState } from "react";
import TableColumnContainer from "components/TableColumnContainer";
import {
  Breadcrumbs,
  Button,
  DetailDrawer,
  InnoTable,
  Popover,
  TableList,
  Tabs,
} from "InnoUI/components";
import { TextInput } from "InnoUI/innoinput";
import { TimeZoneWithCountryDropdown } from "components";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { apiDelete, apiGet, apiPost } from "api/callApi";
import DeleteComponent from "../DeleteComponent";
import Vector from "@assets/icons/Vector.png";
import ct from "countries-and-timezones";
import { InnoTableDefaultPageSize, regexTypes } from "utils/config";
import SC from "./style";
import { useLocation, useNavigate } from "react-router";
import theme from "theme";
import AddEditHoliday from "./AddEditHolidays";
import styled from "@emotion/styled";
import LinkProjects from "./LinkProjects";
import { showAlert } from "utils/helper";

const Holidays = (props) => {
  const { popupState } = props;
  const [data, setData] = useState([]);
  const [country, setCountry] = useState("ZA");
  const [selectedTab, setSelectedTab] = useState(0);
  const [openDeleteView, setOpenDeleteView] = useState(false);
  const [fieldId, setFieldId] = useState();
  const [countryOptions, setCountryOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const currentYear = new Date().getFullYear();
  const [searchdate, setSearchdate] = useState({
    fromDate: null,
    toDate: null,
  });
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [openDrwer, setOpenDrwer] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(InnoTableDefaultPageSize.pageSize);

  const currentPath = location.pathname;

  const breadcrumbItems = [
    { label: "Admin Settings" },
    { label: "Holidays", href: "/admin-settings/holidays" },
  ];

  const handleBreadcrumbClick = (href) => {
    if (href) {
      navigate(href);
    }
  };

  useEffect(() => {
    const allCountries = ct.getAllCountries();
    const countryList = Object.values(allCountries).map((country) => ({
      label: country.name,
      value: country.id,
      timezones: country.timezones,
    }));

    const allCountriesOption = {
      label: "All",
      value: "all",
      timezones: [], // You can leave timezones as an empty array if not needed
    };

    setCountryOptions(countryList);
  }, []);

  const handleCountryChange = (countryId) => {
    const selectedCountry = countryOptions.find(
      (country) => country.value === countryId
    );
    setCountry(selectedCountry.value);
    setData((prevData) =>
      prevData.map((item) => ({
        ...item,
        countryName: selectedCountry.value,
      }))
    );
  };

  const calculateTotalDays = (start, end) => {
    if (start && end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const timeDiff = endDate - startDate;
      return Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) + 1; // Adding 1 to include both start and end dates
    }
    return 0;
  };

  const onChange = (value, name, rowId, isLocal) => {
    const updatedRow = data.find((item) => item.id === rowId);
    const updatedData = {
      ...updatedRow,
      [name]: value,
    };
    // If the startDate or endDate is being updated, recalculate the total number of days
    if (name === "startDate" || name === "endDate") {
      // const updatedRow = data.find((item) => item.id === rowId);
      const totalNoOfDays = calculateTotalDays(
        updatedData.startDate,
        updatedData.endDate
      );
      updatedData.totalNoOfDays = totalNoOfDays;
    }
    updateData({ id: rowId, newData: updatedData, isLocal: isLocal, name });
  };

  const updateData = async (action) => {
    const { id, newData, isLocal, name } = action;
    try {
      const updatedData = data.map((item) =>
        item.id === id ? { ...item, ...newData } : item
      );
      setData(updatedData); // Update the state with new data
    } catch (error) {
      console.log(error);
    }
  };

  const onSaveAddCallback = async (rowData) => {
    const payload = {
      data: { ...rowData },
    };

    if (!country) {
      showAlert({
        title: "Error",
        text: "Please select country",
        icon: "error",
      });
      return;
    }

    const newData = {
      ...rowData,
      countryName: country,
      holidayType: selectedTab,
    };

    try {
      setIsLoading(true);
      const result = await apiPost("/v1/addholiday", newData);

      // Show success message
      showAlert({ title: "Success", text: result?.message, icon: "success" });

      // Get the new holiday data from the response
      const { data: newHolidayData } = result;

      // Update the data locally after successful save
      const updatedData = data.map((item) =>
        item.id == rowData.id ? { ...item, isLocal: false } : item
      );

      // Insert the new holiday data into the local state
      const updatednNewData = updatedData.map((item) => {
        if (item.id === rowData.id && item.isLocal === false) {
          // If the item is already updated, avoid inserting it again.
          return {
            ...item,
            id: newHolidayData.id, // Use the ID from the result
            holidayName: newHolidayData.holidayName,
            countryName: newHolidayData.countryName,
            startDate: newHolidayData.startDate,
            endDate: newHolidayData.endDate,
            totalNoOfDays: newHolidayData.totalNoOfDays,
            holidayType: newHolidayData.holidayType,
            createOn: newHolidayData.createOn,
            createdBy: newHolidayData.createdBy,
            lastupade: newHolidayData.lastupade,
            lastUpdateBy: newHolidayData.lastUpdateBy,
          };
        }
        return item;
      });

      const filteredData = updatednNewData.filter(
        (item) => item.isLocal !== true
      );

      setData(filteredData);

      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      // Show error alert if the request fails

      showAlert({
        title: "Error",
        text: error?.response?.data?.message,
        icon: "error",
      });
    }
  };

  const onAddCallback = (newRow) => {
    setData([newRow, ...data]);
  };

  const onCancelCallback = (id) => {
    setData(data.filter((item) => item.id !== id));
  };

  const getAlldata = async () => {
    try {
      setIsLoading(true);
      // Base endpoint
      let endpoint = `/v1/getholiday/${selectedTab}`;
      let queryParams = [];
      queryParams.push(`country=${country}`);
      if (searchdate.fromDate && searchdate.toDate) {
        queryParams.push(
          `fromDate=${searchdate.fromDate}&toDate=${searchdate.toDate}`
        );
      }

      if (queryParams.length > 0) {
        endpoint += `?${queryParams.join("&")}`;
      }

      const response = await apiGet(endpoint, false);
      setData(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.message);
    }
  };

  const handleDatechange = (name, value) => {
    setSearchdate({ ...searchdate, [name]: value });
  };

  useEffect(() => {
    getAlldata();
  }, [selectedTab, country, searchdate.fromDate, searchdate.toDate]);

  const onDeleteCallback = (id) => {
    setData(data.filter((item) => item.id !== id));
  };

  const onRowClick = useCallback(() => {}, []);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const generateDummyData = (count) => {
    return {
      id: (parseInt(count) + 1).toString(),
      holidayName: "",
      date: dayjs().format("YYYY-MM-DD"),
      countryName: country,
      isLocal: true,
    };
  };

  const tabData = [
    { value: 0, label: `Public Holidays` },
    { value: 1, label: "Builder Holidays" },
  ];

  const handleDelete = async (id) => {
    try {
      setIsLoading(true);
      const result = await apiDelete(`/v1/holiday/${id}`);
      console.log(result);
      showAlert({ title: "Success", text: result?.message, icon: "success" });

      setOpenDeleteView(false);
      await getAlldata();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      showAlert({
        title: "Error",
        text: error?.result?.data?.message,
        icon: "error",
      });
      setOpenDeleteView(false);
    }
  };

  const onDeleteCallbackModal = (id) => {
    setOpenDeleteView(true);
    setFieldId(id);
  };

  const handleEditClick = (record) => {
    setOpen(true);
    setRowData(record);
  };

  const closeDrawer = () => {
    setOpen(false);
    setRowData(null);
  };
  const closeLinkProjectDrawer = () => {
    setOpenDrwer(false);
    setRowData(null);
  };

  const handleLinkProjects = (record) => {
    setOpenDrwer(true);
    setRowData(record);
  };

  const checkboxChangeCallback = (data, state) => {
    if (state) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, data]);
    } else {
      const newData = selectedItems.filter((item) => data !== item);
      setSelectedItems(newData);
    }
  };

  const allCheckboxChangeCallback = (data, state) => {
    if (state) {
      setSelectedItems(data);
    } else {
      setSelectedItems([]);
    }
  };

  const handleLinkToProject = async () => {
    if (selectedItems.length === 0) {
      showAlert({
        title: "Warning",
        text: "Please select a file.",
        icon: "warning",
      });
      return;
    }
    const data = {
      id: selectedItems,
      countryName: country,
    };
    setOpenDrwer(true);
    setRowData(data);

    // setSelectedItems([]);
  };

  const publicholidayColumn = [
    {
      title: "S.No.",
      dataIndex: "id",
      width: 50,
      render(value, record, index) {
        const serialNumber = (currentPage - 1) * pageSize + index + 1;
        return <SC.ValueSpan>{serialNumber}</SC.ValueSpan>;
      },
    },
    {
      title: "Holiday Name",
      width: 200,
      dataIndex: "holidayName",
      render(value, record) {
        const commonProps = {
          isTextArea: false,
          defaultValue: value,
          name: "holidayName",
          variant: "borderless",
          rowId: record.id,
          disabled: false,
          focus: record.isLocal,
          autoFocus: record.isLocal,
          onChange: (value, key) =>
            onChange(value, key, record.id, record.isLocal),
          regexType: regexTypes.textOnly,
        };
        const menuItems = [
          {
            id: 1,
            text: "Edit",
            onClick: () => handleEditClick(record),
          },
        ];
        return record.isLocal ? (
          <TableColumnContainer>
            <TextInput {...commonProps} />
          </TableColumnContainer>
        ) : (
          <SC.PopoverContainer>
            <SC.ValueSpanP>{value}</SC.ValueSpanP>
            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <>
                    <div
                      style={{
                        width: "50px",
                        textAlign: "center",
                        justifyContent: "end",
                        display: "flex",
                        marginRight: "5px",
                      }}
                    >
                      <SC.PopoverSpan>
                        <SC.MoreVertIcon />
                      </SC.PopoverSpan>
                    </div>
                  </>
                ),
              }}
              popoverContent={
                <TableList
                  sx={{
                    borderBottom: `1px solid ${theme.colors.bordertask}`,
                  }}
                  items={menuItems || []}
                  popupState={popupState}
                />
              }
            />
          </SC.PopoverContainer>
        );
      },
    },

    {
      title: "Date",
      width: 200,
      dataIndex: "date",
      render(value, record) {
        return record.isLocal ? (
          <TableColumnContainer>
            <DatePicker
              name="date"
              placeholder="Please Select"
              value={value ? dayjs(value, "YYYY-MM-DD") : null}
              format="YYYY-MM-DD"
              onChange={(value) => {
                const formattedDate = value ? value.format("YYYY-MM-DD") : "";
                onChange(formattedDate, "date", record.id, record.isLocal); // Update date for this row
              }}
              style={{ width: "90%", height: "30px", borderRadius: 0 }}
            />
          </TableColumnContainer>
        ) : (
          <span>{record.startDate}</span>
        );
      },
    },
    {
      title: "Country Name",
      width: 200,
      dataIndex: "countryName",
      render(value, record) {
        const country = ct.getCountry(value);
        return <span>{country?.name}</span>;
      },
    },
  ];

  const builderColumn = [
    {
      title: "S.No.",
      dataIndex: "id",
      width: 50,
      render(value, record, index) {
        const serialNumber = (currentPage - 1) * pageSize + index + 1;
        return <SC.ValueSpan>{serialNumber}</SC.ValueSpan>;
      },
    },
    {
      title: "Holiday Name",
      width: 200,
      dataIndex: "holidayName",
      render(value, record) {
        const commonProps = {
          isTextArea: false,
          defaultValue: value,
          name: "holidayName",
          variant: "borderless",
          rowId: record.id,
          disabled: false,
          focus: record.isLocal,
          autoFocus: record.isLocal,
          onChange: (value, key) =>
            onChange(value, key, record.id, record.isLocal),
          regexType: regexTypes.textOnly,
        };
        const menuItems = [
          {
            id: 1,
            text: "Edit",
            onClick: () => handleEditClick(record),
          },
          {
            id: 2,
            text: "Manage Link Projects",
            onClick: () => handleLinkProjects(record),
          },
        ];
        return record.isLocal ? (
          <TableColumnContainer>
            <TextInput {...commonProps} />
          </TableColumnContainer>
        ) : (
          <SC.PopoverContainer>
            <SC.ValueSpanP>{value}</SC.ValueSpanP>
            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <>
                    <div
                      style={{
                        width: "50px",
                        textAlign: "center",
                        justifyContent: "end",
                        display: "flex",
                        marginRight: "5px",
                      }}
                    >
                      <SC.PopoverSpan>
                        <SC.MoreVertIcon />
                      </SC.PopoverSpan>
                    </div>
                  </>
                ),
              }}
              popoverContent={
                <TableList
                  sx={{
                    borderBottom: `1px solid ${theme.colors.bordertask}`,
                  }}
                  items={menuItems || []}
                  popupState={popupState}
                />
              }
            />
          </SC.PopoverContainer>
        );
      },
    },
    {
      title: "Start Date",
      width: 200,
      dataIndex: "startDate",
      render(value, record) {
        return record.isLocal ? (
          <TableColumnContainer>
            <DatePicker
              name="startDate"
              placeholder="Please Select"
              value={value ? dayjs(value, "YYYY-MM-DD") : null}
              format="YYYY-MM-DD"
              onChange={(value) => {
                const formattedDate = value ? value.format("YYYY-MM-DD") : "";
                onChange(formattedDate, "startDate", record.id, record.isLocal); // Update date for this row
              }}
              style={{ width: "90%", height: "30px", borderRadius: 0 }}
              disabledDate={(current) => {
                // Ensure that the current date is before the startDate for that row
                return current && current > dayjs(record.endDate, "YYYY-MM-DD");
              }}
            />
          </TableColumnContainer>
        ) : (
          <span>{value}</span>
        );
      },
    },
    {
      title: "End Date",
      width: 200,
      dataIndex: "endDate",
      render(value, record) {
        return record.isLocal ? (
          <TableColumnContainer>
            <DatePicker
              name="endDate"
              placeholder="Please Select"
              value={value ? dayjs(value, "YYYY-MM-DD") : null}
              format="YYYY-MM-DD"
              onChange={(value) => {
                const formattedDate = value ? value.format("YYYY-MM-DD") : "";
                onChange(formattedDate, "endDate", record.id, record.isLocal); // Update date for this row
              }}
              style={{ width: "90%", height: "30px", borderRadius: 0 }}
              disabledDate={(current) => {
                // Ensure that the current date is before the startDate for that row
                return (
                  current && current < dayjs(record.startDate, "YYYY-MM-DD")
                );
              }}
            />
          </TableColumnContainer>
        ) : (
          <span>{value}</span>
        );
      },
    },
    {
      title: "Total Days",
      width: 200,
      dataIndex: "totalNoOfDays",
      onCell: () => ({
        style: { padding: "0px 0px 0px 30px" },
      }),

      render(value, record) {
        return record.isLocal ? (
          <TableColumnContainer>
            <span>
              {record.totalNoOfDays ||
                calculateTotalDays(record.startDate, record.endDate)}
            </span>
          </TableColumnContainer>
        ) : (
          <span>{value}</span>
        );
      },
    },
    {
      title: "Linked Projects",
      width: 200,
      dataIndex: "linkprojectCount",
      onCell: () => ({
        style: { padding: "0px 0px 0px 30px" },
      }),
      render(value, record) {
        return (
          <span
            onClick={() => {
              handleLinkProjects(record);
            }}
            style={{
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "bold",
              color: theme.colors.themeColor,
              textDecoration: "underline",
            }}
          >
            {value || 0}
          </span>
        );
      },
    },
    {
      title: "Country Name",
      width: 200,
      dataIndex: "countryName",
      render(value, record) {
        const country = ct.getCountry(value);
        return <span>{country?.name}</span>;
      },
    },
  ];

  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: true,
    addNew: false,
    search: false,
    action: true,
    divBorder: true,
    sno: false,
    addDummyData: true,
    pagination: {
      current: currentPage, // current page number
      pageSize: pageSize, // page size state
      // pageSizeOptions: ["20", "50", "100"], // options shown in the dropdown
      showSizeChanger: true, // enable page size dropdown
      onChange: (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize); // this is important to update
      },
    },
  };

  const builderConfig = {
    draggable: false,
    selection: true,
    expandable: true,
    addNew: false,
    search: false,
    action: true,
    divBorder: true,
    sno: false,
    addDummyData: true,
    pagination: {
      current: currentPage, // current page number
      pageSize: pageSize, // page size state
      // pageSizeOptions: ["20", "50", "100"], // options shown in the dropdown
      showSizeChanger: true, // enable page size dropdown
      onChange: (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize); // this is important to update
      },
    },
  };

  const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `;

  const FilterContainer = styled.div`
    display: flex;
    align-items: center;
  `;

  const FilterLabel = styled.span`
    display: flex;
    align-items: center;
    font-weight: bold;
    margin: 20px;
  `;

  const FilterIcon = styled.img`
    margin-right: 5px;
    height: 15px;
    width: 15px;
  `;

  const StyledDatePicker = styled(DatePicker)`
    width: 30%;
    height: 30px;
    margin: 5px;
    border: 1px solid ${theme.colors.themeColor};
  `;

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={currentPath}
        onClick={handleBreadcrumbClick}
      />
      <div style={{ marginTop: "50px" }}>
        <Tabs
          value={selectedTab}
          label={tabData.map((tab) => tab.label) || []}
          onChange={handleTabChange}
          selectedValue={selectedTab}
        />
      </div>
      <div>
        <Container>
          <FilterContainer>
            <FilterLabel>
              <FilterIcon src={Vector} alt="filter" />
              Date Range
            </FilterLabel>
            <StyledDatePicker
              name="fromDate"
              placeholder="From date"
              value={
                searchdate.fromDate
                  ? dayjs(searchdate.fromDate, "YYYY-MM-DD")
                  : null
              }
              format="YYYY-MM-DD"
              onChange={(value) => {
                const formattedDate = value
                  ? dayjs(value).format("YYYY-MM-DD")
                  : "";
                handleDatechange("fromDate", formattedDate);
              }}
              mode="date"
              showTime={false}
              allowClear={true}
            />
            <StyledDatePicker
              name="toDate"
              placeholder="To date"
              value={
                searchdate.toDate
                  ? dayjs(searchdate.toDate, "YYYY-MM-DD")
                  : null
              }
              format="YYYY-MM-DD"
              onChange={(value) => {
                const formattedDate = value
                  ? dayjs(value).format("YYYY-MM-DD")
                  : "";
                handleDatechange("toDate", formattedDate);
              }}
              mode="date"
              showTime={false}
              allowClear={true}
            />
          </FilterContainer>
        </Container>
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              position: "absolute",
              right: "20px",
              gap: "50px",
              justifyContent: "space-between",
            }}
          >
            {selectedTab == 1 && (
              <Button
                caption={"Link to project"}
                color={
                  selectedItems.length == 0 ? "black" : theme.colors.themeColor
                }
                fontSize="12px"
                style={{
                  background:
                    selectedItems.length == 0 ? theme.colors.bordertask : "",
                  minWidth: "90px",
                  height: "28px",
                  borderRadius: "3px",
                  border:
                    selectedItems.length == 0
                      ? "1px  solid  black"
                      : `1px solid ${theme.colors.themeColor}`,
                  opacity: selectedItems.length == 0 ? 0.6 : 1,
                }}
                onClick={handleLinkToProject}
                disabled={selectedItems.length == 0}
              />
            )}
            <div>
              <span style={{ fontSize: "13px", fontWeight: "bold" }}>
                Selected Country:
              </span>
              <TimeZoneWithCountryDropdown
                placeholder="Select Country"
                options={countryOptions}
                value={country}
                onChange={handleCountryChange}
                width="250px"
                margin="10px"
                style={{
                  border: `1px solid ${theme.colors.themeColor}`,
                  borderRadius: "6px",
                }}
              />
            </div>
          </div>
          {selectedTab == 0 && (
            <InnoTable
              tableConfig={tableConfig}
              padding={"10px"}
              column={publicholidayColumn}
              data={data}
              onRowClickCallback={onRowClick}
              tableKey={"Holiday"}
              generateDummyData={generateDummyData}
              onSaveAddCallback={onSaveAddCallback}
              onDeleteCallback={onDeleteCallback}
              onAddCallback={onAddCallback}
              onCancelCallback={onCancelCallback}
              onDeleteCallbackModal={onDeleteCallbackModal}
              loading={isLoading}
            />
          )}
          {selectedTab == 1 && (
            <InnoTable
              tableConfig={builderConfig}
              padding={"10px"}
              column={builderColumn}
              data={data}
              onRowClickCallback={onRowClick}
              tableKey={"Holiday"}
              generateDummyData={generateDummyData}
              onSaveAddCallback={onSaveAddCallback}
              onDeleteCallback={onDeleteCallback}
              onAddCallback={onAddCallback}
              onCancelCallback={onCancelCallback}
              onDeleteCallbackModal={onDeleteCallbackModal}
              loading={isLoading}
              selectedItems={selectedItems}
              checkboxChangeCallback={checkboxChangeCallback}
              allCheckboxChangeCallback={allCheckboxChangeCallback}
            />
          )}
        </div>
      </div>
      {openDeleteView && (
        <DeleteComponent
          title={"Delete Holidays"}
          messageData={"Are you sure you want to Delete this Holiday?"}
          setOpenDeleteView={setOpenDeleteView}
          openDeleteView={openDeleteView}
          handleDelete={() => handleDelete(fieldId)}
          handleArchive={() => setOpenDeleteView(false)}
          firstButtontext={"Cancel"}
        />
      )}

      {open && (
        <DetailDrawer
          open={open}
          onClose={closeDrawer}
          title={false}
          width={"650px"}
          children={
            <AddEditHoliday
              onClose={closeDrawer}
              rowData={rowData}
              fetchdata={getAlldata}
              selectedTab={selectedTab}
            />
          }
        />
      )}
      {openDrwer && (
        <DetailDrawer
          open={openDrwer}
          onClose={closeLinkProjectDrawer}
          title={false}
          width={"650px"}
          children={
            <LinkProjects
              onClose={closeLinkProjectDrawer}
              holidayData={rowData}
              fetchdata={getAlldata}
              selectedTab={selectedTab}
              setSelectedItem={setSelectedItems}
              setOpenDrwer={setOpenDrwer}
            />
          }
        />
      )}
    </>
  );
};

export default Holidays;
